import { GQL_currentUnitPaycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import { ALL_PAYCHECK_PERIODS } from '@/queries/PaycheckPeriod';
import uniq from 'lodash/uniq';
import dayjs from '@/utils/dayjs';
import { apolloProvider } from '@/utils/vue-apollo';

const client = apolloProvider.defaultClient;

export function uniqueDescendingYears(years: number[]): number[] {
  return uniq(years).sort((year1, year2) => year1 > year2 ? -1 : 1);
}

export function periodYears(): Promise<number[]> {
  return client
    .query({
      query: ALL_PAYCHECK_PERIODS,
    })
    .then(({data}: { data: GQL_currentUnitPaycheckPeriods }) => {
      const years = data.currentUnit.paycheckPeriods.map(p => dayjs(p.bookkeepingPeriod, 'YYYY-MM', true).year());
      return uniqueDescendingYears(years);
    });
}
